import React, { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

export default function AdminStandalone() {
  const [list, setList] = useState([])
  const [edits, setEdits] = useState({})
  const [neu, setNeu] = useState({ codice: '', nome: '', partner: '', prezzo_annuo: 0 })
  const [loading, setLoading] = useState(true)

  useEffect(() => { load() }, [])
  async function load() {
    setLoading(true)
    const { data } = await supabase.from('standalone_prodotti').select('*').order('nome')
    setList(data || [])
    setLoading(false)
  }

  async function save(codice) {
    const p = edits[codice]; if (!p) return
    await supabase.from('standalone_prodotti').update(p).eq('codice', codice)
    setEdits(s => { const x={...s}; delete x[codice]; return x })
    load()
  }
  async function add() {
    if (!neu.codice || !neu.nome) return
    await supabase.from('standalone_prodotti').insert(neu)
    setNeu({ codice:'', nome:'', partner:'', prezzo_annuo: 0 })
    load()
  }
  async function del(codice) {
    if (!window.confirm('Eliminare questo prodotto?')) return
    await supabase.from('standalone_prodotti').delete().eq('codice', codice)
    load()
  }
  function setF(codice, k, v) {
    setEdits(s => ({ ...s, [codice]: { ...(s[codice]||{}), [k]: v }}))
  }

  if (loading) return <div className="loading">Caricamento...</div>

  return (
    <div>
      <div className="page-header">
        <h1>Stand alone</h1>
        <p>Prodotti a premio annuo fisso vendibili indipendentemente dalla CVT.</p>
      </div>
      <div className="card">
        <table>
          <thead><tr><th>Codice</th><th>Nome</th><th>Partner</th><th>Prezzo annuo</th><th>Attivo</th><th></th></tr></thead>
          <tbody>
            {list.map(p => {
              const e = edits[p.codice] || {}
              const v = (k) => e[k] !== undefined ? e[k] : p[k]
              const dirty = Object.keys(e).length > 0
              return (
                <tr key={p.codice}>
                  <td><strong>{p.codice}</strong></td>
                  <td><input value={v('nome')||''} onChange={x => setF(p.codice,'nome',x.target.value)} /></td>
                  <td><input value={v('partner')||''} onChange={x => setF(p.codice,'partner',x.target.value)} /></td>
                  <td><input type="number" step="0.01" value={v('prezzo_annuo')||0} onChange={x => setF(p.codice,'prezzo_annuo',parseFloat(x.target.value))} style={{ width: 100 }} /></td>
                  <td><input type="checkbox" checked={!!v('attivo')} onChange={x => setF(p.codice,'attivo',x.target.checked)} /></td>
                  <td>
                    {dirty && <button className="btn btn-sm btn-primary" onClick={() => save(p.codice)}>Salva</button>}
                    <button className="btn btn-sm btn-danger" style={{ marginLeft: 8 }} onClick={() => del(p.codice)}>×</button>
                  </td>
                </tr>
              )
            })}
            <tr>
              <td><input value={neu.codice} placeholder="CODICE" onChange={e => setNeu(s => ({...s, codice: e.target.value.toUpperCase()}))} style={{ width:120 }} /></td>
              <td><input value={neu.nome} placeholder="Nome" onChange={e => setNeu(s => ({...s, nome: e.target.value}))} /></td>
              <td><input value={neu.partner} placeholder="Partner" onChange={e => setNeu(s => ({...s, partner: e.target.value}))} /></td>
              <td><input type="number" step="0.01" value={neu.prezzo_annuo} onChange={e => setNeu(s => ({...s, prezzo_annuo: parseFloat(e.target.value)}))} style={{ width:100 }} /></td>
              <td></td>
              <td><button className="btn btn-sm btn-primary" onClick={add}>+ Aggiungi</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}
